export const themes = {
    HighContrastTheme: {
        displayName: 'Midnight',
        backgroundColor: 'black',
        buttonNames: 'DefaultButtons',
        cardFaceColor: '#E8E8E8',
        cardBackColor: '#2A2A3A',
        cardBackName: 'midnight-geometric',
        placeholderColor: '#FFFFFF33',
        highlightColor: '#FFFFFF',
        fillColor: '#FFFFFF',
        textColor: '#FFFFFF',
        textColorShadow: '#FFFFFF33',
        redCardColor: '#6080A8',
        blackCardColor: '#1A1A2E',
        cardBorderColor: 'rgba(0, 0, 0, 0.30)',
    },
    ClassicGreenTheme: {
        displayName: 'Classic',
        backgroundColor: '#1B5E20',
        buttonNames: 'DefaultButtons',
        cardFaceColor: '#FFF8E7',
        cardBackColor: '#6B1C2A',
        cardBackName: 'classic-plaid',
        placeholderColor: '#FFFFFF22',
        highlightColor: '#E0D89A',
        fillColor: '#E0D89A',
        textColor: '#E0D89A',
        textColorShadow: '#E0D89A33',
        redCardColor: '#8B1A2B',
        blackCardColor: '#1B4420',
        cardBorderColor: 'rgba(0, 0, 0, 0.25)',
    },
    PleasedPinkTheme: {
        displayName: 'Coral',
        backgroundColor: '#C12849',
        buttonNames: 'PleasedPinkTheme',
        cardFaceColor: '#FFFFFF',
        cardBackColor: '#8B2040',
        cardBackName: 'coral-elegant',
        placeholderColor: '#F8E5EB77',
        highlightColor: '#F8E5EB',
        fillColor: '#F8E5EB',
        textColor: '#F8E5EB',
        textColorShadow: '#F8E5EB77',
        redCardColor: '#B91252',
        blackCardColor: '#3A3A4A',
        cardBorderColor: 'rgba(0, 0, 0, 0.25)',
    },
    SoftBlueTheme: {
        displayName: 'Ocean',
        backgroundColor: '#268bd2',
        buttonNames: 'SoftBlueTheme',
        cardFaceColor: '#F0F4F8',
        cardBackColor: '#1A3A5C',
        cardBackName: 'ocean-waves',
        placeholderColor: '#DFDCECAA',
        highlightColor: '#DFDCEC',
        fillColor: '#DFDCEC',
        textColor: '#DFDCEC',
        textColorShadow: '#DFDCECAA',
        redCardColor: '#C05030',
        blackCardColor: '#1A3050',
        cardBorderColor: 'rgba(0, 0, 0, 0.25)',
    },
    HappyPurpleTheme: {
        displayName: 'Twilight',
        backgroundColor: '#292D3E',
        buttonNames: 'DefaultButtons',
        cardFaceColor: '#F5F0FA',
        cardBackColor: '#5E35A0',
        cardBackName: 'twilight-celestial',
        placeholderColor: '#B996E633',
        highlightColor: '#B996E6',
        fillColor: '#B996E6',
        textColor: '#B996E6',
        textColorShadow: '#B996E633',
        redCardColor: '#6A3E96',
        blackCardColor: '#2A2A40',
        cardBorderColor: 'rgba(0, 0, 0, 0.25)',
    },
    ForestTheme: {
        displayName: 'Forest',
        backgroundColor: '#33402E',
        buttonNames: 'DefaultButtons',
        cardFaceColor: '#FBF5EC',
        cardBackColor: '#6B3A28',
        cardBackName: 'forest-nature',
        placeholderColor: '#D4A56A33',
        highlightColor: '#D4A56A',
        fillColor: '#D4A56A',
        textColor: '#D4A56A',
        textColorShadow: '#D4A56A33',
        redCardColor: '#C45A30',
        blackCardColor: '#2A3820',
        cardBorderColor: 'rgba(0, 0, 0, 0.25)',
    },
}
